import React, { useEffect } from 'react';
import '../styles/alert.css';

const Alert = ({ type = 'error', title, message, onClose, autoClose = false }) => {
  useEffect(() => {
    if (autoClose && type === 'success') {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [autoClose, type, onClose]);

  const icons = {
    success: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
    error: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    ),
    warning: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
    ),
  };

  const titles = {
    success: 'Operación exitosa',
    error: 'Error',
    warning: 'Advertencia',
    info: 'Información',
  };

  return (
    <div className="alert-overlay">
      <div className={`alert-box alert-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className={`alert-icon-circle alert-icon-${type}`}>
          {icons[type]}
        </div>
        <h3 className="alert-title">{title || titles[type]}</h3>
        <p className="alert-message">{message}</p>
        <button className={`alert-btn alert-btn-${type}`} onClick={onClose}>
          Aceptar
        </button>
      </div>
    </div>
  );
};

export default Alert;
